























import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

interface ILocale {
  code: string
  label: string
}

@Component
export default class LangChanger extends Vue {
  @Getter
  public locale!: string
  @Action
  public setLocale!: any
  public lang: string = ''
  public locales: ILocale[] = [
    {
      code: 'en',
      label: 'English'
    },
    {
      code: 'fr',
      label: 'Français'
    }
  ]

  public mounted(): void {
    this.lang = this.locale
  }

  @Watch('lang')
  public onlangChange(locale: string): void {
    if (locale !== this.locale) {
      this.setLocale(locale)
    }
    if (locale !== this.$i18n.locale) {
      this.$i18n.locale = locale
    }
  }

  @Watch('locale', { immediate: true })
  public onLocaleChange(locale: string): void {
    if (locale !== this.lang) {
      this.lang = locale
    }
  }
}
